"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./functions"), exports);
var createManagedClients_1 = require("./createManagedClients");
Object.defineProperty(exports, "createManagedClients", { enumerable: true, get: function () { return createManagedClients_1.default; } });
var createRegionalManagedClients_1 = require("./createRegionalManagedClients");
Object.defineProperty(exports, "createRegionalManagedClients", { enumerable: true, get: function () { return createRegionalManagedClients_1.default; } });
__exportStar(require("./types"), exports);
//# sourceMappingURL=index.js.map